const PaymentDetails = ({ payment, onClose }) => {
  if (!payment) return null;


  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return 'N/A';
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: (payment.currency || 'CAD').toUpperCase()
    }).format(amount);
  };

  const formatDate = (value) => {
    if (!value) return '-';
    const d = new Date(value);
    return isNaN(d.getTime()) ? '-' : d.toLocaleDateString();
  };

  const statusBadge = (status) => {
    const map = {
      COMPLETED: 'bg-success',
      PROCESSING: 'bg-warning text-dark',
      FAILED: 'bg-danger',
      CANCELLED: 'bg-secondary',
      CREATED: 'bg-info text-dark'
    };
    const cls = map[status] || 'bg-light text-dark';
    return <span className={`badge ${cls}`}>{status || '-'}</span>;
  };

  return (
    <>
      <div  className="modal fade show d-block"
        style={{ zIndex: '9999' }}
        tabIndex="-1"
        role="dialog">
        <div
          className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
          style={{ maxWidth: '920px', maxHeight: '80vh' }}
        >
          <div className="modal-content" >

            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">Payment </h5>
              <button type="button" className="btn-close btn-close-white" onClick={onClose} />
            </div>

            <div className="modal-body" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
              <div className="row g-3">

                <div className="col-md-6">
                  <div className="card h-100">
                    <div className="card-header bg-light"><strong>Summary</strong></div>
                    <div className="card-body">
                      <p className="mb-1 border-bottom"><strong>Amount:</strong> {formatCurrency(payment.amount)}</p>
                      <p className="mb-1 border-bottom"><strong>Status:</strong> {statusBadge(payment.status)}</p>
                      <p className="mb-1 border-bottom"><strong>Provider:</strong> {payment.provider || '-'}</p>
                      <p className="mb-1 border-bottom"><strong>Method:</strong> {payment.payment_method || '-'}</p>
                      <p className="mb-1 border-bottom"><strong>Purpose:</strong> {payment.purpose || '-'}</p>
                      <p className="mb-1 border-bottom"><strong>Currency:</strong> {(payment.currency || 'CAD').toUpperCase()}</p>
                      <p className="mb-1 border-bottom"><strong>Created:</strong> {formatDate(payment.createdAt)}</p>
                      {/* <p className="mb-1"><strong>Updated:</strong> {formatDate(payment.updatedAt)}</p> */}
                      <p className="mb-1 border-bottom"><strong>Rent Month:</strong> {formatDate(payment.payment_recieved_for_month)}</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="card h-100">
                    <div className="card-header bg-light"><strong>People</strong></div>
                    <div className="card-body">
                      <p className="mb-1"><strong>Payer:</strong> {payment.payer ? `${payment.payer.first_name} ${payment.payer.last_name}` : '-'}</p>
                      <p className="mb-1 text-muted border-bottom">{payment.payer?.email || ''}</p>
                      <p className="mb-1"><strong>Payee:</strong> {payment.payment_receiver ? `${payment.payment_receiver.first_name} ${payment.payment_receiver.last_name}` : '-'}</p>
                      <p className="mb-1 text-muted border-bottom" >{payment.payment_receiver?.email || ''}</p>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="card">
                    <div className="card-header bg-light"><strong>Lease & Property</strong></div>
                    <div className="card-body">
                      {payment.lease ? (
                        <div className="row">
                          <div className="col-md-4">
                            <p className="mb-1 border-bottom"><strong>Lease:</strong> {payment.lease.lease_name}</p>
                            <p className="mb-1 border-bottom"><strong>Status:</strong> {payment.lease.status}</p>
                            <p className="mb-1 border-bottom"><strong>Type:</strong> {payment.lease.lease_type}</p>
                          </div>
                          <div className="col-md-4">
                            <p className="mb-1 border-bottom"><strong>Property:</strong> {payment.lease.property?.property_name || '-'}</p>
                            <p className="mb-1 border-bottom"><strong>Address:</strong> {payment.lease.property ? `${payment.lease.property.street_number || ''} ${payment.lease.property.street_name || ''}, ${payment.lease.property.city || ''}` : '-'}</p>
                            <p className="mb-1 border-bottom"><strong>Unit:</strong> {payment.lease.unit?.unit || '-'}</p>
                          </div>
                          <div className="col-md-4">
                            <p className="mb-1 border-bottom"><strong>Next Payment:</strong> {formatDate(payment.lease.next_payment_date)}</p>
                            <p className="mb-1 border-bottom"><strong>Last Payment:</strong> {formatDate(payment.lease.last_payment_date)}</p>
                            <p className="mb-1 border-bottom"><strong>Base Rent:</strong> {formatCurrency(payment.lease.base_rent_for_unit)}</p>
                          </div>
                        </div>
                      ) : (
                        <p className="text-muted mb-0">No lease linked to this payment.</p>
                      )}
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>Close</button>
            </div>

          </div>
        </div>
      </div>
      {/* <div className="modal-backdrop fade show" onClick={onClose} /> */}
        {/* BACKDROP */}
      <style jsx>{`
        .modal.show {
          background-color: rgba(0, 0, 0, 0.5);
        }
      `}</style>
    </>
  );
};

export default PaymentDetails;
